import React from 'react';
import { GetServerSideProps } from 'next';
import getConfig from 'next/config';
import { NextSeo } from 'next-seo';
import BasicLayout from 'layout/Basic';
import GalleryDetails, { Props } from 'containers/Gallery/Details';
import { convertProps } from 'lib/parseAPIResponse';

export const GalleryDetailsPage = (props: Props): React.JSX.Element => {
    const { gallery } = props;
    const { url } = getConfig().publicRuntimeConfig;

    const description = gallery.seoDescription || gallery.description?.replace(/<[^>]*>?/gm, '');
    return (
        <BasicLayout ads={props.ads}>
            <NextSeo
                title={gallery.seoTitle || gallery.title}
                canonical={`${url}/galerie/${gallery.seoSlug}`}
                description={description}
                openGraph={{
                    title: gallery.title,
                    description: description,
                    url: `${url}/galerie/${gallery.seoSlug}`,
                    images: gallery.images.map((image) => ({
                        url: image,
                        alt: gallery.title
                    }))
                }}
            />
            <GalleryDetails {...props} />
        </BasicLayout>
    );
};

export const getServerSideProps: GetServerSideProps = async ({ params, query }) => {
    const slugParams = params.slug as string;
    const [slug, image] = slugParams.split(',');
    const { apiUrl } = getConfig().publicRuntimeConfig;

    const queryParams = query._previewKey ? `?_previewKey=${query._previewKey}` : '';

    const path = `/public/api/galleries/${slug}`;
    const url = apiUrl + path;
    return Promise.all([
        fetch(url + queryParams),
        fetch(`${apiUrl}/public/api/naszadsik?path=galleries/${slug}`)
    ]).then(async ([res1, res2]) => {
        const data = await res1.json();
        if (data.code === 404) {
            return {
                notFound: true
            };
        }
        if (data.code === 403) {
            return {
                props: {
                    error: { ...convertProps(data) }
                }
            };
        }
        const ads = await res2.json();

        return {
            props: {
                ...convertProps(ads),
                ...convertProps(data),
                image: image ? Number.parseInt(image) : 0
            }
        };
    });
};

export default GalleryDetailsPage;
